import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "position-relative",
  ref: "datePickerContainer"
}
const _hoisted_2 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      class: "form-control bg-body-bg position-relative border",
      style: {"width":"216px","height":"30px","padding-left":"35px"},
      placeholder: _ctx.formattedDateRange,
      onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDatePicker && _ctx.toggleDatePicker(...args)))
    }, null, 40, _hoisted_2),
    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-calendar-line position-absolute top-50 start-0 translate-middle-y ps-3 fs-15" }, null, -1)),
    _createElementVNode("div", {
      class: _normalizeClass(['date-picker', { active: _ctx.isDatePickerActive }]),
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createVNode(_component_DatePicker, {
        modelValue: _ctx.selected,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event))
      }, null, 8, ["modelValue"])
    ], 2)
  ], 512))
}